const translations = {
  en: {
    // ── Header / Nav ──
    nav: {
      home: "HOME",
      analysis: "AI-ANALYSIS",
      about: "ABOUT US",
      premium: "PREMIUM",
    },
    auth: {
      signIn: "Sign in",
      signUp: "Sign up",
      signOut: "Sign out",
      signedInAs: "Signed in as",
      handicap: "Handicap",
      country: "Country",
      credits: "Credits",
      plan: "Plan",
      planFree: "Free",
      planPro: "Pro",
      planPremium: "Premium",
    },

    // ── Footer ──
    footer: {
      tagline: "AI-powered coaching for every golfer",
      product: "Product",
      social: "Social",
      contacts: "Contact",
      rights: "All rights reserved.",
      legal: "Legal",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      consent: "Personal Data Consent",
    },

    // ── Home ──
    home: {
      heroEyebrow: "AI-POWERED GOLF COACHING",
      heroTitle: "YOUR PERSONAL",
      heroTitleAccent: "AI GOLF COACH",
      heroSub: "Analyze your swing,\nspot mistakes,\nand get tailored drills\n—",
      heroSubStrong: "all from a single video",
      heroBtn: "Start Now →",

      howEyebrow: "THE PROCESS",
      howTitle: "How does it work?",
      steps: [
        { label: "Record",      desc: "Film your swing from any angle with your phone." },
        { label: "Upload",      desc: "Drop the video into the app — one tap." },
        { label: "Get Analysis",desc: "Instant AI breakdown with personalised drills." },
      ],

      whyEyebrow: "WHY SWINGMENTOR",
      whyTitle: "Everything you need to improve",
      features: [
        { title: "Pose Detection",   desc: "Computer-vision skeleton tracking on every frame of your swing." },
        { title: "AI Feedback",      desc: "GPT-powered coaching notes written in plain language." },
        { title: "Progress Graph",   desc: "Track your improvement over time with visual metrics." },
        { title: "Tour Comparisons", desc: "See how your swing stacks up against PGA tour benchmarks." },
        { title: "Mobile-First",     desc: "Built for your phone — record and analyze anywhere." },
        { title: "Instant Results",  desc: "Full analysis delivered in under 3 seconds." },
      ],

      downloadEyebrow: "IN YOUR POCKET",
      downloadTitle: "Train.\nAnytime.\nAnywhere.",
      downloadSub: "With your personal AI-mentor always on hand",
      downloadBtn: "Download",

      aboutEyebrow: "OUR STORY",
      aboutTitle: "Welcome to",
      aboutTitleAccent: "SWINGMENTOR",
      aboutText: "We aim to make golf accessible to anyone at any time. Our AI-powered mobile app provides insights, tips, and training tailored just for you — join us as we usher in a new era of golfing excellence with the perfect blend of experience and technology.",
      aboutBtn: "Learn more →",
    },

    // ── About page ──
    about: {
      heroEyebrow: "Our Story",
      welcomeTitle: "Welcome to",
      welcomeAccent: "SWINGMENTOR",
      welcomeText: "We aim to make golf accessible to anyone at any time. Our AI-powered mobile app provides you with insights, tips, and training tailored just for you — join us as we usher in a new era of golfing excellence with the perfect blend of experience and technology.",
      elevateEyebrow: "In your pocket",
      elevateTitle: "Elevate your game",
      elevateSub: "Swing by Swing",
      downloadBtn: "Download",
      missionCards: [
        { title: "Precision", text: "AI skeleton tracking on every frame — spot the exact moment your swing breaks down." },
        { title: "Progress",  text: "Visual metrics and session history let you see improvement over time, not just feel it." },
        { title: "Access",    text: "Great coaching shouldn't require a country-club budget. SwingMentor brings it to everyone." },
      ],
    },

    // ── AI Mentors ──
    mentors: {
      eyebrow: "AI-POWERED ANALYSIS",
      title: "Upload your swing video",
      sub: "Upload a short swing video to receive scores, key issues, and a personalized practice plan.",
      authTitle: "Sign in to analyze your swing",
      authText: "Video analysis uses your personal credits and saves the result to your account, so authorization is required.",
      credits: "{{count}} credits available",
      limits: "Up to {{seconds}} seconds and {{megabytes}} MB",
      estimate: "{{seconds}} sec video, estimated charge: {{credits}} credits",
      filmingGuideEyebrow: "BEFORE UPLOADING",
      filmingGuideTitle: "How to film your swing",
      filmingGuideImageAlt: "Example of a golfer fully visible in the camera frame",
      filmingGuideAngle: "Place the camera behind the golfer and point it down the target line.",
      filmingGuideHeight: "Secure the phone at about waist height. Portrait or landscape orientation is fine.",
      filmingGuideFrame: "Keep the golfer, hands, club, and ball visible from setup through the finish. Use even lighting.",
      trimNoticeTitle: "Trim the video before uploading",
      trimNoticeText: "Remove pauses before the swing and after the finish. Credits are charged by video duration, so a shorter clip uses fewer credits and is processed faster.",
      tokenPremium: "✓ {{tier}} — {{count}} credits",
      tokenLeft_one: "{{count}} credit left",
      tokenLeft_other: "{{count}} credits left",
      tokenNone: "0 credits — upgrade",
      upgradeLink: "Get Pro / Premium →",
      dropTitle: "Drop your video here",
      videoSelected: "Video selected",
      dropHint: "or click to browse — MP4, MOV, AVI",
      analyzeBtn: "Analyze Swing →",
      uploadingBtn: "Uploading...",
      analyzingBtn: "Analyzing…",
      coachNotes: "Coach Notes",
      processedVideo: "Processed Video",
      preparingPreview: "Preparing preview…",
      downloadBtn: "Open or download processed video",
      emptyTitle: "Your analysis will appear here",
      emptyHint: "Upload a swing video to get started",
      loadingText: "Your swing is being analyzed",
      loadingHint: "Analysis can take several minutes. You may leave this page and return later; the task will resume automatically.",
      yourVideo: "Your video",
      analysisReady: "Analysis ready",
      genericSummary: "The analysis is ready. Use the scores and practice plan below for your next training session.",
      improvements: "What to improve",
      strengths: "Strengths",
      practicePlan: "Practice plan",
      repetitions: "Repetitions",
      drill: "Drill",
      feelCue: "What to feel",
      successCheck: "How to know it is working",
      swing: "Swing",
      score_posture: "Posture",
      score_timing: "Timing",
      score_rotation: "Rotation",
      invalidFile: "Choose a valid video file.",
      fileTooLarge: "The video must not exceed 100 MB.",
      videoTooLong: "The video must not exceed {{seconds}} seconds.",
      uploadFailed: "Could not upload the video.",
      processingFailed: "Video processing failed. Reserved credits were returned when possible.",
      alreadyProcessing: "Another video is already being analyzed. Its status has been restored.",
      taskNotFound: "The saved analysis task was not found. Please upload the video again.",
      sessionExpired: "Your session has expired. Sign in again.",
    },

    // ── Subscription page ──
    subscription: {
      heroBadge: "🏌️ SwingMentor Premium",
      heroTitle: "Get better with",
      heroTitleAccent: "every swing",
      heroSub: "Unlimited AI analysis, personal coaching, and progress history — all in one subscription.",
      activeBadge: "✓ You have an active Premium subscription",
      tokensLeft: "Credits remaining: {{count}}",
      plansEyebrow: "Plans",
      plansTitle: "Choose your plan",
      featuresEyebrow: "Features",
      featuresTitle: "Everything included in Premium",
      compareEyebrow: "Compare",
      compareTitle: "Free vs Premium",
      faqEyebrow: "FAQ",
      faqTitle: "Common questions",
      ctaTitle: "Ready to level up your swing?",
      ctaSub: "Join thousands of players who've already improved their game with SwingMentor",
      payBtn: "Subscribe →",
      payBtnActive: "Subscription active",
      payBtnLoading: "Redirecting to payment…",
      paymentSyncFailed: "Could not confirm the payment yet. Please refresh the page.",
      payLegal: "RUB via YooKassa · International crypto payments via Trybit · Cancel any time",
      billingMonthly: "Monthly",
      billingYearly: "Yearly",
      billingSaveLabel: "Save 17%",
      currencyLabel: "Currency",
      creditsPerMonth: "credits / mo",
      creditsPerYear: "credits / yr",
      plans: [
        { id: "pro_monthly",     tier: "pro",     billing: "monthly", label: "Pro",     credits: 500,  per: "/ month", note: null,          perNote: "Cancel any time" },
        { id: "pro_yearly",      tier: "pro",     billing: "yearly",  label: "Pro",     credits: 6000, per: "/ year",  note: "Save 17%",    perNote: "Best value" },
        { id: "premium_monthly", tier: "premium", billing: "monthly", label: "Premium", credits: 1500, per: "/ month", note: null,          perNote: "Cancel any time" },
        { id: "premium_yearly",  tier: "premium", billing: "yearly",  label: "Premium", credits: 18000,per: "/ year",  note: "Save 17%",    perNote: "Best value" },
      ],
      features: [
        { icon: "🎥", title: "High-volume analysis",         desc: "Upload as many swings as your credits allow — Pro gets 500, Premium gets 1500 per month." },
        { icon: "🤖", title: "AI coaching from top mentors", desc: "Get advice in the style of Tiger Woods, Rory McIlroy and Collin Morikawa." },
        { icon: "📊", title: "Progress graph & history",     desc: "Track improvements for every swing parameter over time." },
        { icon: "🎯", title: "Personalised recommendations", desc: "AI picks drills specifically for your weak points." },
        { icon: "⚡", title: "Priority processing",          desc: "Your videos go first — results in 10–30 seconds." },
        { icon: "📱", title: "Any device",                   desc: "Web and mobile app — synced automatically." },
      ],
      compareRows: [
        ["Credits / month",         "30",  "500",  "1 500" ],
        ["AI coaching",             "✓",   "✓",    "✓"     ],
        ["Session history",         "—",   "✓",    "✓"     ],
        ["Progress graph",          "—",   "✓",    "✓"     ],
        ["Personalised recs",       "—",   "✓",    "✓"     ],
        ["Priority processing",     "—",   "✓",    "✓"     ],
      ],
      compareHeaders: ["", "Free", "Pro", "Premium"],
      faqs: [
        { q: "Can I cancel my subscription?",    a: "Yes, at any time from your account settings. Access remains until the end of the paid period." },
        { q: "How does payment work?",           a: "RUB payments go through YooKassa. International users can pay by crypto through Trybit. Payments are confirmed automatically." },
        { q: "What happens when it expires?",    a: "Your account reverts to the free plan. 30 free credits are restored." },
        { q: "What's the difference between Pro and Premium?", a: "Pro gives 500 credits/month, Premium gives 1500 credits/month. Both include AI coaching and progress history." },
        { q: "Is there a trial period?",         a: "Yes! Every new user gets 30 free credits — no card required." },
      ],
      planSelectedLabel: "✓ Selected",
      planSelectLabel: "Select",
      ctaBtnStart: "Get started →",
    },

    // ── Register ──
    register: {
      tagline: "Create your account",
      firstName: "First name",
      lastName: "Last name (optional)",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm password",
      handicap: "Handicap (optional)",
      country: "Country",
      countryPlaceholder: "Select your country",
      legalPrefix: "I accept the",
      terms: "Terms of Service",
      legalAnd: "and",
      privacy: "Privacy Policy",
      submitBtn: "Create account →",
      loadingBtn: "Creating…",
      success: "Account created! Redirecting…",
      haveAccount: "Already have an account?",
      signIn: "Sign in",
      errors: {
        fillRequired: "Please fill in all required fields.",
        firstName: "First name is required.",
        password: "Passwords do not match.",
        passwordLength: "Password must be at least 10 characters.",
        countryRequired: "Please select your country.",
        legalRequired: "Please accept the Terms of Service and Privacy Policy.",
      },
    },

    // ── Log In ──
    login: {
      tagline: "Welcome back",
      email: "Email",
      password: "Password",
      country: "Account country",
      countryPlaceholder: "Select your country",
      submitBtn: "Sign in →",
      loadingBtn: "Signing in…",
      noAccount: "Don't have an account?",
      signUp: "Sign up",
      forgotPassword: "Forgot password?",
      passwordResetSuccess: "Password updated. Sign in with your new password.",
      fillAllFields: "Please fill in all fields.",
      countryRequired: "Please select your account country.",
    },
    passwordReset: {
      title: "Reset your password",
      requestDescription: "Enter your account email. We will send a 6-digit reset code.",
      resetDescription: "Enter the code from the email and choose a new password.",
      emailRequired: "Enter a valid email address.",
      code: "Reset code",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      codeSent: "If the account exists, a reset code was sent.",
      requestFailed: "Could not request a password reset. Try again.",
      invalidCode: "The reset code is invalid or has expired.",
      passwordLength: "Password must be at least 10 characters.",
      passwordMismatch: "Passwords do not match.",
      sendCode: "Send reset code →",
      submit: "Set new password →",
      loading: "Please wait…",
      back: "Back to sign in",
    },

    // ── Subscription Modal ──
    modal: {
      badge: "🏌️ SwingMentor Pro / Premium",
      title: "Get more credits",
      subtitle: "You've used all your free credits",
      perks: [
        "500–1500 credits per month",
        "AI coaching from top mentors",
        "Progress graph & session history",
        "Personalised recommendations",
      ],
      payBtn: "Pay →",
      payBtnLoading: "Redirecting…",
      legal: "RUB via YooKassa · International crypto via Trybit.",
      currencyLabel: "Currency",
      billingMonthly: "Monthly",
      billingYearly: "Yearly",
      billingSaveLabel: "Save 17%",
    },
  },

  // ════════════════════════════════════════════════════
  ru: {
    nav: {
      home: "ГЛАВНАЯ",
      analysis: "AI-АНАЛИЗ",
      about: "О НАС",
      premium: "ПРЕМИУМ",
    },
    auth: {
      signIn: "Войти",
      signUp: "Регистрация",
      signOut: "Выйти",
      signedInAs: "Вы вошли как",
      handicap: "Гандикап",
      country: "Страна",
      credits: "Кредиты",
      plan: "Тариф",
      planFree: "Бесплатно",
      planPro: "Pro",
      planPremium: "Premium",
    },

    footer: {
      tagline: "AI-коучинг для каждого гольфиста",
      product: "Продукт",
      social: "Соцсети",
      contacts: "Контакты",
      rights: "Все права защищены.",
      legal: "Документы",
      terms: "Публичная оферта",
      privacy: "Политика конфиденциальности",
      consent: "Согласие на обработку ПДн",
    },

    home: {
      heroEyebrow: "AI-КОУЧИНГ ДЛЯ ГОЛЬФА",
      heroTitle: "ВАШ ЛИЧНЫЙ",
      heroTitleAccent: "AI ТРЕНЕР",
      heroSub: "Анализируй свинг, находи ошибки\nи получай персональные упражнения —",
      heroSubStrong: "всё из одного видео",
      heroBtn: "Начать →",

      howEyebrow: "КАК ЭТО РАБОТАЕТ",
      howTitle: "Как это работает?",
      steps: [
        { label: "Снимите",   desc: "Запишите свинг под любым углом с телефона." },
        { label: "Загрузите", desc: "Загрузите видео в приложение — одно нажатие." },
        { label: "Получите анализ", desc: "Разбивка от AI с персональными упражнениями." },
      ],

      whyEyebrow: "ПОЧЕМУ SWINGMENTOR",
      whyTitle: "Всё, что нужно для роста",
      features: [
        { title: "Отслеживание поз",    desc: "Computer-vision скелет на каждом кадре вашего свинга." },
        { title: "AI-обратная связь",   desc: "Коучинговые заметки на основе GPT, написанные понятным языком." },
        { title: "График прогресса",    desc: "Отслеживайте улучшения с визуальными метриками." },
        { title: "Сравнение с туром",   desc: "Как ваш свинг соотносится с эталонами PGA-тура." },
        { title: "Mobile-First",        desc: "Создано для телефона — снимайте и анализируйте где угодно." },
        { title: "Мгновенный результат",desc: "Полный анализ менее чем за 3 секунды." },
      ],

      downloadEyebrow: "В ВАШЕМ КАРМАНЕ",
      downloadTitle: "Тренируйся.\nГде угодно.\nКогда угодно.",
      downloadSub: "Ваш личный AI-ментор всегда рядом",
      downloadBtn: "Скачать",

      aboutEyebrow: "НАША ИСТОРИЯ",
      aboutTitle: "Добро пожаловать в",
      aboutTitleAccent: "SWINGMENTOR",
      aboutText: "Мы делаем гольф доступным для каждого. Наше AI-приложение даёт советы, подсказки и тренировки, подобранные лично для вас.",
      aboutBtn: "Узнать больше →",
    },

    about: {
      heroEyebrow: "Наша история",
      welcomeTitle: "Добро пожаловать в",
      welcomeAccent: "SWINGMENTOR",
      welcomeText: "Мы делаем гольф доступным для каждого в любое время. Наше AI-приложение даёт вам советы, подсказки и тренировки, подобранные лично для вас — присоединяйтесь к нам в новой эре гольфа с идеальным сочетанием опыта и технологий.",
      elevateEyebrow: "В вашем кармане",
      elevateTitle: "Выведите игру на новый уровень",
      elevateSub: "Свинг за свингом",
      downloadBtn: "Скачать",
      missionCards: [
        { title: "Точность",     text: "AI-отслеживание скелета на каждом кадре — найдите точный момент поломки свинга." },
        { title: "Прогресс",     text: "Визуальные метрики и история сессий покажут улучшения, а не просто дадут их почувствовать." },
        { title: "Доступность",  text: "Отличный коучинг не должен требовать членства в закрытом клубе. SwingMentor для всех." },
      ],
    },

    mentors: {
      eyebrow: "AI-АНАЛИЗ",
      title: "Загрузите видео свинга",
      sub: "Загрузите короткое видео свинга, чтобы получить оценки, ключевые ошибки и персональный план тренировки.",
      authTitle: "Войдите, чтобы проанализировать свинг",
      authText: "Анализ расходует ваши персональные кредиты и сохраняется в аккаунте, поэтому нужна авторизация.",
      credits: "Доступно кредитов: {{count}}",
      limits: "До {{seconds}} секунд и {{megabytes}} МБ",
      estimate: "Видео {{seconds}} сек., примерная стоимость: {{credits}} кредитов",
      filmingGuideEyebrow: "ПЕРЕД ЗАГРУЗКОЙ",
      filmingGuideTitle: "Как правильно снять свинг",
      filmingGuideImageAlt: "Пример съёмки гольфиста целиком в кадре",
      filmingGuideAngle: "Поставьте камеру позади игрока и направьте её по линии удара.",
      filmingGuideHeight: "Закрепите телефон примерно на уровне пояса. Вертикальная или горизонтальная ориентация не важна.",
      filmingGuideFrame: "Игрок, руки, клюшка и мяч должны быть видны от стойки до финиша. Снимайте при ровном освещении.",
      trimNoticeTitle: "Обрежьте видео перед загрузкой",
      trimNoticeText: "Удалите паузу до начала замаха и всё лишнее после финиша. Кредиты списываются за длительность видео: короткий ролик расходует меньше кредитов и обрабатывается быстрее.",
      tokenPremium: "✓ {{tier}} — {{count}} кредитов",
      tokenLeft_one: "{{count}} кредит остался",
      tokenLeft_other: "{{count}} кредитов осталось",
      tokenNone: "0 кредитов — обновить",
      upgradeLink: "Получить Pro / Premium →",
      dropTitle: "Перетащите видео сюда",
      videoSelected: "Видео выбрано",
      dropHint: "или нажмите, чтобы выбрать — MP4, MOV, AVI",
      analyzeBtn: "Анализировать свинг →",
      uploadingBtn: "Загружаем...",
      analyzingBtn: "Анализируем…",
      coachNotes: "Заметки тренера",
      processedVideo: "Обработанное видео",
      preparingPreview: "Подготовка превью…",
      downloadBtn: "Открыть или скачать обработанное видео",
      emptyTitle: "Здесь появится ваш анализ",
      emptyHint: "Загрузите видео свинга, чтобы начать",
      loadingText: "Анализируем ваш свинг",
      loadingHint: "Анализ может занять несколько минут. Можно уйти со страницы и вернуться позже — задача восстановится автоматически.",
      yourVideo: "Ваше видео",
      analysisReady: "Анализ готов",
      genericSummary: "Анализ готов. Ниже — оценки и план тренировки на следующую сессию.",
      improvements: "Что улучшить",
      strengths: "Сильные стороны",
      practicePlan: "План тренировки",
      repetitions: "Повторения",
      drill: "Упражнение",
      feelCue: "Что почувствовать",
      successCheck: "Как понять, что получается",
      swing: "Свинг",
      score_posture: "Поза",
      score_timing: "Тайминг",
      score_rotation: "Вращение",
      invalidFile: "Выберите корректный видеофайл.",
      fileTooLarge: "Размер видео не должен превышать 100 МБ.",
      videoTooLong: "Видео должно быть не длиннее {{seconds}} секунд.",
      uploadFailed: "Не удалось загрузить видео.",
      processingFailed: "Обработка видео завершилась ошибкой. Зарезервированные кредиты возвращены, если это было возможно.",
      alreadyProcessing: "Другое видео уже анализируется. Мы восстановили статус этой задачи.",
      taskNotFound: "Сохранённая задача анализа не найдена. Загрузите видео ещё раз.",
      sessionExpired: "Сессия истекла. Войдите снова.",
    },

    subscription: {
      heroBadge: "🏌️ SwingMentor Премиум",
      heroTitle: "Становитесь лучше с",
      heroTitleAccent: "каждым свингом",
      heroSub: "Безлимитный AI-анализ, персональный коучинг и история прогресса — всё в одной подписке.",
      activeBadge: "✓ У вас активная Премиум-подписка",
      tokensLeft: "Кредитов осталось: {{count}}",
      plansEyebrow: "Тарифы",
      plansTitle: "Выберите план",
      featuresEyebrow: "Возможности",
      featuresTitle: "Всё, что входит в Премиум",
      compareEyebrow: "Сравнение",
      compareTitle: "Бесплатно vs Премиум",
      faqEyebrow: "FAQ",
      faqTitle: "Частые вопросы",
      ctaTitle: "Готов прокачать свой свинг?",
      ctaSub: "Присоединяйся к тысячам игроков, которые уже улучшили свою технику с SwingMentor",
      payBtn: "Оформить →",
      payBtnActive: "Подписка уже активна",
      payBtnLoading: "Переход к оплате…",
      paymentSyncFailed: "Пока не удалось подтвердить оплату. Обновите страницу.",
      payLegal: "Рубли — через ЮКассу · Международная криптооплата — через Trybit · Отмена в любой момент",
      billingMonthly: "В месяц",
      billingYearly: "В год",
      billingSaveLabel: "Скидка 17%",
      currencyLabel: "Валюта",
      creditsPerMonth: "кредитов / мес",
      creditsPerYear: "кредитов / год",
      plans: [
        { id: "pro_monthly",     tier: "pro",     billing: "monthly", label: "Pro",     credits: 500,  per: "/ месяц", note: null,           perNote: "Отмена в любой момент" },
        { id: "pro_yearly",      tier: "pro",     billing: "yearly",  label: "Pro",     credits: 6000, per: "/ год",   note: "Скидка 17%",  perNote: "Выгоднее всего" },
        { id: "premium_monthly", tier: "premium", billing: "monthly", label: "Premium", credits: 1500, per: "/ месяц", note: null,           perNote: "Отмена в любой момент" },
        { id: "premium_yearly",  tier: "premium", billing: "yearly",  label: "Premium", credits: 18000,per: "/ год",   note: "Скидка 17%",  perNote: "Выгоднее всего" },
      ],
      features: [
        { icon: "🎥", title: "Большой объём анализов",      desc: "Загружай свинги в пределах кредитов — Pro 500, Premium 1500 в месяц." },
        { icon: "🤖", title: "AI-коучинг от топ-менторов", desc: "Получай советы в стиле Tiger Woods, Rory McIlroy и Collin Morikawa." },
        { icon: "📊", title: "Прогресс-граф и история",    desc: "Отслеживай улучшения по каждому параметру свинга за всё время." },
        { icon: "🎯", title: "Персональные рекомендации",  desc: "AI подбирает упражнения конкретно под твои слабые места." },
        { icon: "⚡", title: "Приоритетная обработка",     desc: "Твои видео обрабатываются первыми — результат за 10–30 секунд." },
        { icon: "📱", title: "Доступ с любого устройства", desc: "Веб и мобильное приложение — синхронизируются автоматически." },
      ],
      compareRows: [
        ["Кредитов / месяц",        "30",  "500",  "1 500" ],
        ["AI-коучинг",              "✓",   "✓",    "✓"     ],
        ["История сессий",          "—",   "✓",    "✓"     ],
        ["Прогресс-граф",           "—",   "✓",    "✓"     ],
        ["Персональные рекомендации","—",  "✓",    "✓"     ],
        ["Приоритетная обработка",  "—",   "✓",    "✓"     ],
      ],
      compareHeaders: ["", "Бесплатно", "Pro", "Premium"],
      faqs: [
        { q: "Могу ли я отменить подписку?",                a: "Да, в любой момент через личный кабинет. Доступ сохраняется до конца оплаченного периода." },
        { q: "Как проходит оплата?",                        a: "Оплата в рублях проходит через ЮКассу. Международные пользователи могут оплатить криптовалютой через Trybit. Платеж подтверждается автоматически." },
        { q: "Что будет после окончания подписки?",         a: "Аккаунт переходит в бесплатный режим. 30 бесплатных кредитов восстанавливаются." },
        { q: "В чём разница между Pro и Premium?",          a: "Pro — 500 кредитов в месяц, Premium — 1500 кредитов в месяц. Оба включают AI-коучинг и историю прогресса." },
        { q: "Есть ли пробный период?",                     a: "Да! Каждый новый пользователь получает 30 бесплатных кредитов — без карты." },
      ],
      planSelectedLabel: "✓ Выбран",
      planSelectLabel: "Выбрать",
      ctaBtnStart: "Начать →",
    },

    register: {
      tagline: "Создать аккаунт",
      firstName: "Имя",
      lastName: "Фамилия (необязательно)",
      email: "Email",
      password: "Пароль",
      confirmPassword: "Подтвердите пароль",
      handicap: "Гандикап (необязательно)",
      country: "Страна",
      countryPlaceholder: "Выберите страну",
      legalPrefix: "Я принимаю",
      terms: "Пользовательское соглашение",
      legalAnd: "и",
      privacy: "Политику конфиденциальности",
      submitBtn: "Создать аккаунт →",
      loadingBtn: "Создаём…",
      success: "Аккаунт создан! Перенаправляем…",
      haveAccount: "Уже есть аккаунт?",
      signIn: "Войти",
      errors: {
        fillRequired: "Заполните все обязательные поля.",
        firstName: "Имя обязательно.",
        password: "Пароли не совпадают.",
        passwordLength: "Пароль должен быть не менее 10 символов.",
        countryRequired: "Выберите страну.",
        legalRequired: "Примите пользовательское соглашение и политику конфиденциальности.",
      },
    },

    login: {
      tagline: "С возвращением",
      email: "Email",
      password: "Пароль",
      country: "Страна аккаунта",
      countryPlaceholder: "Выберите страну",
      submitBtn: "Войти →",
      loadingBtn: "Входим…",
      noAccount: "Нет аккаунта?",
      signUp: "Регистрация",
      forgotPassword: "Забыли пароль?",
      passwordResetSuccess: "Пароль обновлён. Войдите с новым паролем.",
      fillAllFields: "Заполните все поля.",
      countryRequired: "Выберите страну аккаунта.",
    },
    passwordReset: {
      title: "Восстановление пароля",
      requestDescription: "Введите email аккаунта. Мы отправим шестизначный код для сброса пароля.",
      resetDescription: "Введите код из письма и придумайте новый пароль.",
      emailRequired: "Введите корректный email.",
      code: "Код для сброса",
      newPassword: "Новый пароль",
      confirmPassword: "Подтвердите новый пароль",
      codeSent: "Если аккаунт существует, код для сброса отправлен.",
      requestFailed: "Не удалось запросить сброс пароля. Попробуйте ещё раз.",
      invalidCode: "Код неверный или срок его действия истёк.",
      passwordLength: "Пароль должен быть не менее 10 символов.",
      passwordMismatch: "Пароли не совпадают.",
      sendCode: "Отправить код →",
      submit: "Установить новый пароль →",
      loading: "Подождите…",
      back: "Вернуться ко входу",
    },

    modal: {
      badge: "🏌️ SwingMentor Pro / Premium",
      title: "Получить больше кредитов",
      subtitle: "Ваши бесплатные кредиты закончились",
      perks: [
        "500–1500 кредитов в месяц",
        "AI-коучинг от топ-менторов",
        "Прогресс-граф и история сессий",
        "Персональные рекомендации",
      ],
      payBtn: "Оплатить →",
      payBtnLoading: "Переход к оплате…",
      legal: "Рубли — через ЮКассу · Международная криптооплата — через Trybit.",
      currencyLabel: "Валюта",
      billingMonthly: "В месяц",
      billingYearly: "В год",
      billingSaveLabel: "Скидка 17%",
    },
  },
};

export default translations;
